import { render, staticRenderFns } from "./WorkHourTrendChart.vue?vue&type=template&id=d4ee2fbc&scoped=true"
import script from "./WorkHourTrendChart.vue?vue&type=script&lang=js"
export * from "./WorkHourTrendChart.vue?vue&type=script&lang=js"
import style0 from "./WorkHourTrendChart.vue?vue&type=style&index=0&id=d4ee2fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ee2fbc",
  null
  
)

export default component.exports